import type {Comment, Thread} from '@github-ui/diff-lines/conversation-types'

export interface PendingComment {
  commentID: number
  thread: Thread
}

export function getFirstComment(thread: Thread): Comment | undefined {
  return thread.commentsData?.comments?.[0]
}
